"use strict";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = function () {
  function Plugin(parent) {
    _classCallCheck(this, Plugin);

    this.parent = parent;
    this.paused = false;
  }
  /**
   * handler for pointerdown PIXI event
   * @param {PIXI.interaction.InteractionEvent} event
   */


  _createClass(Plugin, [{
    key: "down",
    value: function down(event) {}
    /**
     * handler for pointermove PIXI event
     * @param {PIXI.interaction.InteractionEvent} event
     */

  }, {
    key: "move",
    value: function move(event) {}
    /**
     * handler for pointerup PIXI event
     * @param {PIXI.interaction.InteractionEvent} event
     */

  }, {
    key: "up",
    value: function up(event) {}
    /**
     * handler for wheel event on div
     * @param {WheelEvent} event
     */

  }, {
    key: "wheel",
    value: function wheel(event) {}
    /**
     * called on each tick
     */

  }, {
    key: "update",
    value: function update() {}
    /**
     * called when the viewport is resized
     */

  }, {
    key: "resize",
    value: function resize() {}
    /**
     * called when the viewport is manually moved
     */

  }, {
    key: "reset",
    value: function reset() {}
    /**
     * called when viewport is paused
     */

  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
    /**
     * called when viewport is resumed
     */

  }, {
    key: "resume",
    value: function resume() {
      this.paused = false;
    }
  }]);

  return Plugin;
}();